import sw from 'js/lib/sw';

/**
 * VueSwMixin
 * Loads sw.js on the Vue instance.
 */
export default {
  beforeCreate() {
    this.$sw = sw;
  }
};
